<template>
  <modal size="xl" @close="$emit('close')">
    <div class="flex flex-wrap">
      <div class="w-full md:w-1/4">
        <avatar class="ml-2 self-center" size="32" :user="user" />
      </div>

      <div class="w-full md:w-3/4 md:pl-4">
        <h3 class="text-xl bold">
          <username :user="user" />
        </h3>
        <h4 class="text-lg">{{ user.name }}</h4>
        <strong>{{ role }}</strong>
        <p
          class="text-sm italic mb-2"
          v-if="user.role === 'moderator'"
        >{{ moderatedChannels.join(', ') }}</p>
        <div class="w-full" v-if="!loading">
          <ul>
            <li>Threads Created: {{ data.thread_count }}</li>
            <li>Replies Created: {{ data.reply_count }}</li>
            <li v-if="user.location">Location: {{ data.location }}</li>
            <li>Current Local Time: {{ nowInTimezone(data.timezone) }}</li>
            <li>Member Since {{ fromNow(data.created_at) }} ({{ dateFormat(data.created_at, 'MMM Do YYYY')}})</li>
            <li>Last Active {{ fromNow(data.last_active_at) }}</li>
          </ul>
          <div v-if="data.signature" class="mt-2">
            <p class="mb-1">Signature:</p>
            <div class="w-full mt-2 border-t border-grey-7 pb-2" v-html="data.signature"></div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import DateTime from "@/mixins/DateTime"
import { mapGetters } from "vuex"
import { flatMap, filter } from "lodash"

export default {
  name: "UserItem",
  mixins: [DateTime],
  props: {
    user: {
      required: true
    }
  },
  data() {
    return {
      data: {},
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      categories: "categories/list"
    }),
    channels() {
      return flatMap(this.categories, "channels")
    },
    moderatedChannels() {
      if (this.user.role !== "moderator") return []
      return filter(this.channels, item => {
        return this.user.moderatable_channels.indexOf(item.slug) !== -1
      }).map(item => {
        return item.name
      })
    },
    role() {
      if (this.user.role === "admin") return "Admin"
      if (this.user.role === "super-moderator") return "Super Moderator"
      if (this.user.role === "moderator") return "Moderator"
      return "User"
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      this.$api.users.show(this.user.username).then(({ data }) => {
        this.data = data
      })
      this.loading = false
    }
  },
  mounted() {
    this.fetch()
  }
}
</script>
